// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vmtf","title":"styles_title__3dx-R"};